// Final branded visuals — swap files in /public/images keeping the same names to replace.
// .webp versions are served (PNG originals kept alongside as source).
export const IMAGES = {
  cn: {
    hero: { src: "/images/mbpayvia-cn-hero.webp", w: 1536, h: 1024 },
    rate: { src: "/images/mbpayvia-cn-rate-0.9.webp", w: 1672, h: 941 },
    campaign: { src: "/images/mbpayvia-cn-campaign.webp", w: 1672, h: 941 },
  },
  en: {
    hero: { src: "/images/mbpayvia-en-hero.webp", w: 1672, h: 941 },
    rate: { src: "/images/mbpayvia-en-rate-0.9.webp", w: 1672, h: 941 },
    campaign: { src: "/images/mbpayvia-en-campaign.webp", w: 1672, h: 941 },
  },
};
